import { render, staticRenderFns } from "./ExCommitment.vue?vue&type=template&id=5df063bd"
import script from "./ExCommitment.vue?vue&type=script&lang=js"
export * from "./ExCommitment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports